import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TriggerInterface } from 'app/models/trigger.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { TriggerDataTransformPost } from './data-transforms/trigger.data.transform.post';
import { TriggerDataTransformGet } from './data-transforms/trigger.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class TriggerHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/triggers(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformUp: TriggerDataTransformGet,
    private readonly _transformDown: TriggerDataTransformPost,
  ) {}

  intercept(req: HttpRequest<TriggerInterface>, next: HttpHandler): Observable<HttpEvent<TriggerInterface>> {
    return RequestService.getTransformedHttpEvent<TriggerInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
